import { FC, useEffect } from 'react';

interface Props {
    isVisible: boolean;
}

const LoadingModal: FC<Props> = ({ isVisible }) => {
    useEffect(() => {
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            bodyElement.style.overflowY = isVisible ? 'hidden' : 'scroll';
        }
    }, [isVisible]);

    if (isVisible) {
        return (
            <div className="loadingModal">
                <div className="errea-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }
    return null;
};

export default LoadingModal;
